export default __webpack_public_path__ + "static/media/NewMoreNavsIcon.4f823419.svg";